module.exports = __webpack_public_path__ + "static/amplifon-logo-56577e70e122ef689aca03093aae5e81.png";